import styled from 'styled-components';
import { dropdownLegendTemplate } from '../../../../../../utils/common.styles';
import { defaultTheme } from '../../../../../../utils/defaultTheme';

const LegendWrapper = styled.div`
    border-radius: 3px;
    box-shadow: 0px 0px 8px #00000029;
    min-height: 50px;
    font-size: 14px;
    margin: 23px 0px 0px 0;
    align-items: center;
    justify-content: space-evenly;
    ${({ styleObject }) => styleObject};
`;

const OptionGroupWrapper = styled.div`
    padding: 3px 10px 9px 10px;
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    align-items: center;
    justify-content: space-evenly;
    ${({ styleObject }) => styleObject};
`;

const OptionWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    flex-basis: calc(100% / 8);
    ${({ styleObject }) => styleObject};

    label {
        display: block;
        max-width: ${props => (props.labelWidth ? props.labelWidth : '100px')};
        word-break: break-word;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        color: ${props => props.theme.blue[900]};
    }
    @media screen and (max-width: 1513px) {
        flex-basis: calc(100% / 6);
    }

    @media screen and (max-width: 1083px) {
        flex-basis: calc(100% / 5);
    }
`;

const LegendLine = styled.div`
    margin-bottom: 0px;
    line-height: 10px;
    ${dropdownLegendTemplate};
`;

const GlobalOptionsWrapper = styled.div`
    width: 100%;
    min-height: 50px;
    border-bottom: 1px solid ${defaultTheme.grey['200']};
`;

const ResetLOBIconWrapper = styled.div`
    display: flex;
    align-items: center;
    width: 32px;
    height: 32px;
    background-color: ${defaultTheme.white.ff};
    box-shadow: 0px 0px 6px ${defaultTheme.black['29']};
    border: 1px solid ${defaultTheme.grey['30']};
    border-radius: 20px;
    opacity: 1;
    cursor: ${props => (props.disabled ? 'none' : 'pointer')};
    pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
    position: absolute;
    margin-left: -15px;

    &:hover {
        background-color: ${defaultTheme.grey['50']};
    }

    svg {
        opacity: ${props => (props.disabled ? '0.3' : '1')};
    }
`;

export { LegendWrapper, OptionWrapper, LegendLine, OptionGroupWrapper, GlobalOptionsWrapper, ResetLOBIconWrapper };
